import type { ReactNode } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./App";
import CognitoryGovernedSourceViewPage from "./components/CognitoryGovernedSourceViewPage";
import CognitoryProvisioningSetupPage from "./components/CognitoryProvisioningSetupPage";
import PlatformAdministratorCognitoriesPage from "./components/PlatformAdministratorCognitoriesPage";

// react-router-dom JSX types lag @types/react 18.3; isolate the cast here.
const BrowserRouterShell = BrowserRouter as (props: {
  children?: ReactNode;
}) => JSX.Element;
const RoutesShell = Routes as (props: { children?: ReactNode }) => JSX.Element;
const RouteShell = Route as (props: {
  path: string;
  element: ReactNode;
}) => JSX.Element;

export default function CognitoryAppRouter(): JSX.Element {
  return (
    <BrowserRouterShell>
      <RoutesShell>
        <RouteShell
          path="/cognitory/:cognitoryId/source"
          element={<CognitoryGovernedSourceViewPage />}
        />
        <RouteShell
          path="/admin/cogs"
          element={<PlatformAdministratorCognitoriesPage />}
        />
        <RouteShell
          path="/provisioning-setup/:cognitoryId"
          element={<CognitoryProvisioningSetupPage />}
        />
        <RouteShell path="/*" element={<App />} />
      </RoutesShell>
    </BrowserRouterShell>
  );
}
